module.exports = __webpack_public_path__ + "static/media/fire.2280e6cc.gif";